'use strict';

/**
 * View for rendering a single storage in sub navigation
 *
 * @category   View
 * @module     entities
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/navigation-storages-list-item.hbs');

var NavigationStoragesListItemView = ColidoItemView.extend({
    template: template,

    tagName: 'li',

    className: function() {
        return this.model.get('storType') === 'status' ? 'is-location' : 'is-storage';
    },

    modelEvents: {
        'change sync': 'render',
    },
});

module.exports = NavigationStoragesListItemView;